<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import store from "./utils/storage";
import axios from "axios";
export default {
  name: "App",
  mounted() {
    // this.getNewVersion();
    // this.$once("hook:beforeDestroy", () => {
    //   clearInterval(this.getNewVersions);
    // });
  },
  destroyed() {
    // clearTimeout(this.getNewVersions);
  },
  methods: {
    // getNewVersion() {
    //   let url = `//${window.location.host}/static/version.json`;
    //   axios
    //     .get(url, { headers: { "Cache-Control": "no-cache" } }) // 请求到json文件的内容, 并且禁止缓存
    //     .then((res) => {
    //       this.$message.closeAll();
    //       const version = res.data.version;
    //       const clientVersion = localStorage.getItem("_version_");

    //       console.log("最新版本>>", version);
    //       console.log("当前版本>>", clientVersion);

    //       // 和最新版本不同，刷新页面
    //       if (version !== clientVersion) {
    //         localStorage.setItem("_version_", version);
    //         window.location.reload();
    //       }
    //       this.getNewVersions = setTimeout(this.getNewVersion, 60000);
    //     });
    // },
  },
};
</script>

<style>
@import "./assets/css/base.css";
</style>


// WEBPACK FOOTER //
// src/App.vue